import styled from "styled-components"

import {Label as BaseLabel} from "@irati/ui/src/Typography"

export const Label = styled(BaseLabel)`
  text-transform: capitalize;
`
